import { CreateSnapshotForm_s } from 'components/snapshots/snapshot-styles';
import snapshotService from "data/snapshots";
import moment from "moment";
import "moment-timezone";
import React, { Dispatch, FC, SetStateAction, useState } from 'react';
import { ButtonWithPress_s, Button_s, Label_s } from 'styles/app-styles';



interface Props {
  togglePopover: Dispatch<SetStateAction<boolean>>
  showAssetWarning: boolean
  type: 'folder' | 'property'
}

const CreateSnapshotForm: FC<Props> = (props) => {
  const [autoDownloadSnapshot, setAutoDownload] = useState<boolean>(localStorage.getItem('autoDownloadSnapshot') !== null ? JSON.parse(localStorage.getItem('autoDownloadSnapshot')!) : true)
  const [description, setDescription] = useState<string>(getPlaceholderDescription());
  const contentType = props.type

  function getPlaceholderDescription(): string {
    let created = moment().utc().local().format('MM/DD/YYYY h:mm:ss A');
    let zoneName = moment.tz.guess();
    let timezone = moment.tz(zoneName).zoneAbbr();
    return `Created on: ${created} ${timezone}`;
  }

  function downloadAutoChange(e: React.ChangeEvent<HTMLInputElement>): void {
    const {checked}: {checked: boolean} = e.target;
    localStorage.setItem('autoDownloadSnapshot', checked.toString());
    setAutoDownload(checked);
  }

  function createSnapshot(): void {
    snapshotService.createSnapshot(contentType, description, autoDownloadSnapshot);
    setTimeout(() => props.togglePopover(false), 500)
  }

  return (
    <CreateSnapshotForm_s>
      <div>
        <Label_s>Description</Label_s>
        <textarea
          rows={5}
          defaultValue={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>
      <div>
        <input
          id="autoDownloadSnapshotInput"
          type="checkbox"
          checked={autoDownloadSnapshot}
          onChange={(e) => downloadAutoChange(e)}
        />
        <Label_s htmlFor="autoDownloadSnapshotInput">Download Automatically</Label_s>
      </div>
      { props.showAssetWarning && <div><br/>This snapshot will contain asset links that can only be restored to the same organization. These links will be dropped from copies restored to other organizations.</div> }
      <hr />
      <div>
        <Button_s onClick={()=>props.togglePopover(false)}>
          Cancel
        </Button_s>
        <ButtonWithPress_s primary onClick={()=>createSnapshot()}>
          Save
        </ButtonWithPress_s>
      </div>
    </CreateSnapshotForm_s>
  )
}

export default CreateSnapshotForm

